export default __webpack_public_path__ + "static/media/as-2.ab21231e.png";